import { Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import { EditableDataGrid } from "../../../builderPackage/components/editableDataGrid/editableDataGrid";
import { RowModeIds } from "../../../builderPackage/components/editableDataGrid/editableDataGrid.entity";
import { MuiStack } from "../../../components";
export var LabourDetails = function (props) {
    var onChange = props.onChange, value = props.value, error = props.error, _a = props.name, name = _a === void 0 ? 'labourDetails' : _a;
    var currValue = value[name];
    var LabourColumns = [{
            field: 'ChildName',
            headerName: 'Labour name & code',
            width: 200,
            headerAlign: 'left',
            disableColumnMenu: true,
            renderCell: function (params) {
                if ((params === null || params === void 0 ? void 0 : params.id) === RowModeIds.Aggregation) {
                    return 'Total';
                }
                else {
                    var _params$row, _params$row2, _params$row3;
                    return /*#__PURE__*/ React.createElement(MuiStack, {
                        direction: 'column'
                    }, /*#__PURE__*/ React.createElement(Typography, {
                        sx: {
                            fontSize: 'sm',
                            fontWeight: 'ormal',
                            color: 'text.primary'
                        }
                    }, params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.ItemName), /*#__PURE__*/ React.createElement(Typography, {
                        sx: {
                            fontSize: 'sm',
                            fontWeight: 'ormal',
                            color: 'text.tertiary'
                        }
                    }, params !== null && params !== void 0 && (_params$row2 = params.row) !== null && _params$row2 !== void 0 && _params$row2.ItemCode ? "#".concat(params === null || params === void 0 || (_params$row3 = params.row) === null || _params$row3 === void 0 ? void 0 : _params$row3.ItemCode) : ""));
                }
            }
        }, {
            field: 'ContractTypeName',
            headerName: 'Service type',
            width: 200,
            headerAlign: 'left',
            disableColumnMenu: true
        }, {
            field: 'MechanicName',
            headerName: 'Technician',
            width: 150,
            headerAlign: 'left',
            disableColumnMenu: true
        }, {
            field: 'Rate',
            headerName: 'Rate (₹)',
            width: 100,
            headerAlign: 'left',
            disableColumnMenu: true,
            valueFormatter: function (params) {
                var value = Number(params);
                if (value) {
                    return value === null || value === void 0 ? void 0 : value.toFixed(2);
                }
                else {
                    return '';
                }
            }
        }, {
            field: 'Qty',
            headerName: 'Unit ',
            width: 100,
            headerAlign: 'left',
            disableColumnMenu: true,
            type: 'number'
        }, {
            field: 'StartDateTime',
            headerName: 'Start date time',
            width: 150,
            headerAlign: 'left',
            disableColumnMenu: true,
            renderCell: function (params) {
                var _params$row4;
                var value = params === null || params === void 0 || (_params$row4 = params.row) === null || _params$row4 === void 0 ? void 0 : _params$row4.StartDateTime;
                return /*#__PURE__*/ React.createElement(MuiStack, {
                    direction: "column"
                }, /*#__PURE__*/ React.createElement(Typography, {
                    sx: {
                        fontSize: 'sm',
                        fontWeight: 'normal',
                        color: 'text.primary'
                    }
                }, value ? dayjs.utc(value).format('DD MMM, YYYY') : '-'), /*#__PURE__*/ React.createElement(Typography, {
                    sx: {
                        fontSize: 'sm',
                        fontWeight: 'normal',
                        color: 'text.tertiary'
                    }
                }, value ? dayjs.utc(value).format('hh:mm A') : ''));
            }
        }, {
            field: 'EndDateTime',
            headerName: 'End date time',
            width: 150,
            headerAlign: 'left',
            disableColumnMenu: true,
            renderCell: function (params) {
                var _params$row5;
                var value = params === null || params === void 0 || (_params$row5 = params.row) === null || _params$row5 === void 0 ? void 0 : _params$row5.EndDateTime;
                return /*#__PURE__*/ React.createElement(MuiStack, {
                    direction: "column"
                }, /*#__PURE__*/ React.createElement(Typography, {
                    sx: {
                        fontSize: 'sm',
                        fontWeight: 'normal',
                        color: 'text.primary'
                    }
                }, value ? dayjs.utc(value).format('DD MMM, YYYY') : '-'), /*#__PURE__*/ React.createElement(Typography, {
                    sx: {
                        fontSize: 'sm',
                        fontWeight: 'normal',
                        color: 'text.tertiary'
                    }
                }, value ? dayjs.utc(value).format('hh:mm A') : ''));
            }
        }, {
            field: 'IsOutside',
            headerName: 'Out side labour',
            width: 150,
            headerAlign: 'left',
            disableColumnMenu: true
        }, {
            field: 'Amount',
            headerName: 'Amount (₹)',
            width: 130,
            headerAlign: 'left',
            disableColumnMenu: true,
            type: 'number',
            valueFormatter: function (params) {
                var value = Number(params);
                if (value) {
                    return value === null || value === void 0 ? void 0 : value.toFixed(2);
                }
                else {
                    return '';
                }
            }
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Stack, {
        sx: {
            margin: '0px 24px 20px 24px'
        }
    }, /*#__PURE__*/ React.createElement(EditableDataGrid, {
        dataGridHeader: "Labour Details",
        isCollapsible: true,
        columns: LabourColumns,
        disableAddRow: true,
        disableDeleteRow: true
        // disableToolbarActions
        ,
        dataGridProps: {
            checkboxSelection: false,
            disableRowSelectionOnClick: true,
            hideFooter: true,
            initialState: {
                aggregation: {
                    model: {
                        Qty: 'sum',
                        Amount: 'sum'
                    }
                }
            }
        },
        rows: currValue || [],
        onChange: onChange,
        error: error === null || error === void 0 ? void 0 : error[name]
    })));
};
